// Libraries
import { useState } from "react";
import { Col, ListGroup, Row } from "react-bootstrap";

// Icons
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

// Styles
import "./ChatHistory.scss";

function ChatHistory({
  setAllChatHistory,
  setPreviousChat,
  allChat,
  isDisbaled,
  pid,
  isEVR,
  deleteChat,
  isUseModel,
  setProjectName="",
  showDeleteButton
}) {
  const [hideList, setHideList] = useState(true);
  return (
    <ListGroup className="h-100">
      <ListGroup.Item className="pr-0 custom-cursor-pointer accordion-label">
        <Row className="w-100 h-100">
          <Col
            md={2}
            className="panel-hide"
            onClick={() => allChat.length > 0 && setHideList(!hideList)}
          >
            {hideList ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </Col>
          <Col md={8} className="pr-0 new-chat-label">
            <span onClick={() => setAllChatHistory()} disabled={isDisbaled}>
              {isEVR ? "New Document" : "New Chat"}
            </span>
          </Col>
          <Col
            md={2}
            className="px-0 d-flex justify-content-end new-chat-button"
            onClick={() => setAllChatHistory()}
            disabled={isDisbaled}
          >
            <AddIcon />
          </Col>
        </Row>
      </ListGroup.Item>
      <div className="chat-list-group">
        {hideList &&
          allChat.map((chat) => (
            <ListGroup.Item
              key={chat.pid}
              className={`custom-cursor-pointer accordion-content ${
                chat.pid === pid ? "selected-chat" : ""
              }`}
              disabled={isDisbaled}
            >
              <span
                className="chat-name"
                title={chat.name}
                onClick={() => {setPreviousChat(chat)
                  if(setProjectName!==""){
                    setProjectName(chat.pid)
                  }
                }}
              >
                {chat.name}
              </span>
              {allChat.length > 1 && showDeleteButton && (
                <div
                  className="delete-icon"
                  onClick={() => deleteChat(chat.pid)}
                >
                  <DeleteIcon />
                </div>
              )}
            </ListGroup.Item>
          ))}
      </div>
    </ListGroup>
  );
}

export default ChatHistory;
